import styled from 'styled-components';

export const StyledTabHeader = styled.div`
  width: 100%;
  padding: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0;
  background: ${({ theme }) => theme.buttonDark};
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: end;
  gap: 0.5rem;
`;

export const StyledTab = styled.div`
  border: solid ${({ $selected }) => $selected ? '2px': '1px'} ${({ theme, $selected }) => $selected ? theme.selectionBlue : 'black'};
  border-bottom: 0;
  background: ${({ theme, $selected }) => $selected ? theme.background : theme.background + '88'};
  display: flex;
  cursor: pointer;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0.5rem;
  transition: linear .2s;
  font-family: "BebasNeue";
  font-size: 1.5rem;
  color: white;
  font-weight: 800;

  &:hover {
    border: solid ${({ $selected }) => $selected ? '2px': '1px'} ${({ theme, $selected }) => $selected ? theme.selectionBlue : 'white'};
    border-bottom: 0;
  }
`;

